import script from "./EditModule.vue?vue&type=script&setup=true&lang=js"
export * from "./EditModule.vue?vue&type=script&setup=true&lang=js"

import "./EditModule.vue?vue&type=style&index=0&id=3dc79721&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc79721"]])

export default __exports__